import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

var common = function common(_ref) {
  var hasAuthor = _ref.hasAuthor;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:not(:hover):not(:active) {\n    color: ", ";\n  }\n  font-weight: ", ";\n"])), token('color.text.mediumEmphasis', N500), hasAuthor ? 500 : 'inherit');
};

export var Anchor = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (p) {
  return common(p);
});
export var Span = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (p) {
  return common(p);
});